import { ActionTree } from 'vuex';
import { basePath, ModuleState } from './types';
import { RootState } from '@/types';
import { API, handleError } from '@/helpers/axios'

export const actions: ActionTree<ModuleState, RootState> = {
  async fetchBy({ commit }, { id, accesses = false }: { id: string; accesses: boolean } ) {
    try {
      const response = await API.get(`${basePath}/${id}`, {
        params: { accesses }
      })
      if (response.status === 200) {
        commit('handleResponseFetchBy', { item: response.data })
        return response.data
      }
    }
    catch(error) { handleError(error) }
    return false
  }
}
